import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import styles from './AssignConfirmModal.module.css';

const AssignConfirmModal = ({
  show,
  onCancel,
  onConfirm,
  entry,
  slotLabel,
  newCount,
}) => {
  const [submitting, setSubmitting] = useState(false);

  const handleConfirm = async () => {
    if (submitting) return;
    setSubmitting(true);
    try {
      await onConfirm();
    } finally {
      setSubmitting(false);
    }
  };

  const handleHide = () => {
    if (submitting) return;
    onCancel();
  };

  const entryName = entry ? entry.displayName || entry.sleepScreenId : '';

  return (
    <Modal show={show} onHide={handleHide} backdrop="static" centered>
      <Modal.Header closeButton={!submitting}>
        <Modal.Title>Confirm assignment</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className={styles.bigNumberRow}>
          <span className={styles.bigNumber}>{newCount.toLocaleString()}</span>
          <span className={styles.bigNumberLabel}>
            {newCount === 1 ? 'fridge' : 'fridges'} will be assigned
          </span>
        </div>
        <p className={styles.sentence}>
          to <strong>{entryName}</strong> in the <strong>{slotLabel}</strong>{' '}
          slot.
        </p>

        <dl className={styles.detailsGrid}>
          <dt>Entry</dt>
          <dd>{entryName}</dd>
          <dt>Slot</dt>
          <dd>{slotLabel}</dd>
          <dt>Fridges</dt>
          <dd>{newCount.toLocaleString()}</dd>
        </dl>

        <p className={styles.helper}>
          The new video will start playing within ~15 minutes. Any IDs the
          backend doesn&apos;t recognize will appear in the result report after
          you assign.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className={styles.cancelButton}
          onClick={handleHide}
          disabled={submitting}
        >
          Cancel
        </button>
        <button
          type="button"
          className={styles.confirmButton}
          onClick={handleConfirm}
          disabled={submitting || newCount === 0}
        >
          {submitting
            ? 'Assigning…'
            : `Yes, assign ${newCount.toLocaleString()} ${
                newCount === 1 ? 'fridge' : 'fridges'
              }`}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

AssignConfirmModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  entry: PropTypes.shape({
    sleepScreenId: PropTypes.string,
    displayName: PropTypes.string,
  }),
  slotLabel: PropTypes.string.isRequired,
  newCount: PropTypes.number.isRequired,
};

AssignConfirmModal.defaultProps = {
  entry: null,
};

export default AssignConfirmModal;
